import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type TerminalAndGroupOptionsQueryVariables = GraphQLTypes.Exact<{
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  first?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  includeGroups?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Boolean']['input']>;
  last?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  query?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
}>;

export type TerminalAndGroupOptionsQueryResult = { __typename?: 'Query' } & {
  transportTerminalsAndGroups: { __typename?: 'TerminalAndGroupOptionConnection' } & {
    nodes?: GraphQLTypes.Maybe<
      Array<
        { __typename?: 'TerminalAndGroupOption' } & Pick<GraphQLTypes.TerminalAndGroupOption, 'code' | 'id' | 'label'> & {
            terminals: Array<
              { __typename?: 'TransportTerminal' } & Pick<GraphQLTypes.TransportTerminal, 'code' | 'id' | 'label'>
            >;
          }
      >
    >;
  };
};

export const TerminalAndGroupOptionsDocument = gql`
  query terminalAndGroupOptions(
    $after: String
    $before: String
    $first: Int
    $includeGroups: Boolean
    $last: Int
    $query: String
  ) {
    transportTerminalsAndGroups(
      after: $after
      before: $before
      first: $first
      last: $last
      query: $query
      withGroups: $includeGroups
      withTerminals: true
    ) {
      nodes {
        code
        id
        label
        terminals {
          code
          id
          label
        }
      }
    }
  }
`;
